import styled from 'styled-components';

interface IStatusFinancial {
  color?: string;
}

export const ContainerStatusFinancial = styled.div<IStatusFinancial>`
  display: flex;
  justify-content: center;
  align-items: center;
  background: ${(props) => props.color ?? '#a9a9a9'};
  border-radius: 4px;
  color: #fff;
  font-size: 11px;
  font-weight: 700;
`;
